/** 4px base unit for the design-system spacing scale */
export const spacingUnit = 4 as const;

/** Spacing scale values in pixels */
export const spacing = {
  0: 0,
  2: 2,
  4: 4,
  6: 6,
  8: 8,
  10: 10,
  12: 12,
  14: 14,
  16: 16,
  20: 20,
  24: 24,
  28: 28,
  32: 32,
  36: 36,
  40: 40,
  48: 48,
  64: 64,
  80: 80,
  96: 96,
  128: 128,
} as const;

export type TSpacing = typeof spacing;
